import {
    useContractReads,
    readContracts,
    useAccount,
    useNetwork,
    useBalance,
} from "wagmi";
import {
    getContractReadsGumball,
    getContractReadsAnima,
    contractReadAvalableInfos,
    getContractReadsBurnableName,
    getContractReadsBurnableBalances,
} from "./ContractReads";
import { BigNumber } from "ethers";
import { useInterval } from "../hooks/UseInterval";
import { GumballContainer } from "./GumballContainer";
import { Contracts } from "./Contracts";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { PrizeWallet } from "./PrizeWallet";
import { useState, useEffect, useRef } from "react";
import s from "./Profile.module.css";

const groupNfts = (_tokenData, key) => {
    return _tokenData.reduce((memo, x) => {
        if (!memo[x[key]]) {
            memo[x[key]] = [];
        }
        memo[x[key]].push(x);
        return memo;
    }, {});
};

const Profile = () => {
    const { address, isConnected } = useAccount();
    const { chain } = useNetwork();

    const initialized = useRef(false);
    const bunablesInitialized = useRef(false);
    ``;
    const [show, setShow] = useState("");

    const [nfts, setNfts] = useState({});

    const [useNfts, setUseNfts] = useState({});

    const [count, setCount] = useState(0);

    const [loadedPrizes, setLoadedPrizes] = useState(false);
    const [prizesCount, setPrizesCount] = useState(0);

    const [processingComplete, setProcessingComplete] = useState(false);

    const [animaCost, setAnimaCost] = useState(BigNumber.from(0));
    const [maticCost, setMaticCost] = useState(BigNumber.from(0));
    const [animaDisplayCost, setAnimaDisplayCost] = useState(100);
    const [maticDisplayCost, setMaticDisplayCost] = useState(5);
    const [paused, setPaused] = useState(true);

    const [infos, setInfos] = useState({});
    const [allInfos, setAllInfos] = useState({});

    const [maticEnabled, setMaticEnabled] = useState(false);
    const [burnableEnabled, setBurnableEnabled] = useState(false);
    //const [burnableLimited, setBurnableLimited] = useState(false);
    const [burnableContract, setBurnableContract] = useState("");
    const [burnableIds, setBurnableIds] = useState([]);

    const [burnableName, setBurnableName] = useState("");
    const [burnableSymbol, setBurnableSymbol] = useState("");

    const [burnableBalances, setBurnableBalances] = useState({});
    const [burnableSelectedId, setBurnableSelectedId] = useState(-1);

    const [burnableNfts, setBurnableNfts] = useState([]);

    const [burnableApproved, setBurnableApproved] = useState(false);

    const [availableTokens, setAvailableTokens] = useState(0);

    const [animaDisplayBalance, setAnimaDisplayBalance] = useState(0);
    const [animaBalance, setAnimaBalance] = useState(BigNumber.from(0));
    const [animaDisplayAllowance, setAnimaDisplayAllowance] = useState(0);
    const [animaAllowance, setAnimaAllowance] = useState(BigNumber.from(0));

    const [maticDisplayBalance, setMaticDisplayBalance] = useState(0);
    const [maticBalance, setMaticBalance] = useState(BigNumber.from(0));

    const [gumballDataLoaded, setGumballDataLoaded] = useState(false);
    const [infosComplete, setInfosComplete] = useState(false);

    const [infoStartIndex, setInfoStartIndex] = useState(0);
    const [infoGroupCount, setInfoGroupCount] = useState(0);
    const [infoFetchedCount, setInfoFetchedCount] = useState(0);

    const [lastType, setLastType] = useState("");

    const groupCount = 100;

    const addresses = {
        gumball: import.meta.env.VITE_POLY_GUMBALL,
        anima: import.meta.env.VITE_POLY_ANIMA,
        explorerBase: import.meta.env.VITE_POLY_EXPLORER,
    };

    //matic balance
    const { data: maticBalanceData } = useBalance({
        address: address,
        watch: true,
    });

    useEffect(() => {
        /* console.log(
            `matic balance data => ${JSON.stringify(maticBalanceData)}`
        ); */

        if (maticBalanceData) {
            setMaticBalance(BigNumber.from(maticBalanceData.value.toString()));

            const formatted = parseFloat(maticBalanceData?.formatted).toFixed(
                2
            );

            setMaticDisplayBalance(formatted);
        }
    }, [maticBalanceData]);

    useEffect(() => {
        const getNftsForWallet = async () => {
            let _nfts = [];
            let page = 0;
            let pages = 0;
            let count = 0;

            let url = `${
                import.meta.env.VITE_API_BASE_URL
            }/data/gacha/wallet/${page}`;

            do {
                const res = await fetch(url);
                const data = await res.json();
                count = data.count;
                pages = data.pages;
                page = Number(data.page);
                _nfts = _nfts.concat(data.nfts);
                console.log(
                    `total count: ${count} - fetched ${page} / ${pages} - fetched nftCount: ${_nfts.length}`
                );
                setPrizesCount(_nfts.length);
                url = `${import.meta.env.VITE_API_BASE_URL}/data/gacha/wallet/${
                    page + 1
                }`;
            } while (page < pages);

            setCount(count);

            const _grouped = groupNfts(_nfts, "address");
            setNfts(_grouped);

            setLoadedPrizes(true);
        };

        // call the async generator function
        if (!initialized.current) {
            initialized.current = true;
            getNftsForWallet();
        }
    }, []);

    ///-----------------GUMBALL READS
    const onSuccessGumballRead = (data) => {
        //console.log(`!!!!!!!!!!!!!!!onSuccessGumballRead!!!!!!!!!!!!!!`);

        const [
            _animaCost, //big int 18 decimals
            _maticCost, //big int 18 decimals
            _paused, //bool
            _maticEnabled, //bool
            _burnableEnabled, //bool
            _burnableLimited, //bool
            _burnableContract, //address
            _burnableIds, //big int array
            _availableTokens, //big int
        ] = data;

        setAnimaCost(BigNumber.from(_animaCost.toString()));

        const animadisplay =
            BigNumber.from(_animaCost.toString()) /
            BigNumber.from(10).pow(BigNumber.from(18));
        setAnimaDisplayCost(animadisplay);

        setMaticCost(BigNumber.from(_maticCost.toString()));

        const maticdisplay =
            BigNumber.from(_maticCost.toString()) /
            BigNumber.from(10).pow(BigNumber.from(18));
        setMaticDisplayCost(maticdisplay);

        setPaused(_paused);
        setMaticEnabled(_maticEnabled);
        setBurnableEnabled(_burnableEnabled);
        //setBurnableLimited(_burnableLimited);
        setBurnableContract(_burnableContract);

        const ids = _burnableIds.map((item) => item.toNumber());

        /* console.log(
            `burnable contract: ${_burnableContract} burnable ids: ${JSON.stringify(
                ids
            )}`
        ); */

        setBurnableIds(ids);

        const availableTokens = BigNumber.from(
            _availableTokens.toString()
        ).toNumber();

        setAvailableTokens(availableTokens);

        setGumballDataLoaded(true);
    };

    //configure gumball reads
    const contractReadsGumball = getContractReadsGumball(
        addresses,
        onSuccessGumballRead
    );

    // use the hook to get the state, data is handled in onSuccessResToken
    const { refetch: refetchReadGumball } =
        useContractReads(contractReadsGumball);

    //--------------- fetch burnable data
    // if burnable is enabled
    // we have the burnable contract address, and the burnable ids
    // we need to read burnable contract and get the name + symbol
    // then we need to check user balance for each burnableID
    const onSuccessBurnableNames = (data) => {
        //console.log(`Burnable Names: ${JSON.stringify(data)}`);
        const [_name, _symbol] = data;

        setBurnableName(_name);
        setBurnableSymbol(_symbol);
    };

    //configure burnable read for name
    const contractReadsBurnableNames = getContractReadsBurnableName(
        burnableContract,
        burnableEnabled,
        onSuccessBurnableNames
    );

    const {
        error: errorReadBurnableNames,
        isLoading: isLoadingBurnableNames,
        refetch: refetchBurnableNames,
    } = useContractReads(contractReadsBurnableNames);

    //configure burnable read for balances
    const onSuccessBurnableBalances = (data) => {
        //console.log(`Burnable Balances: ${JSON.stringify(data)}`);

        const [_data, _approved] = data;
        const bals = {};

        burnableIds.forEach((e, i) => {
            //console.log(`_data[${i}] = ${JSON.stringify(_data[i])}`);
            bals[e] = _data[i].toNumber();
        });

        //console.log(`Burnable Balances: ${JSON.stringify(bals)}`);

        setBurnableBalances(bals);
        setBurnableApproved(_approved);
    };

    //configure burnable read for balances
    const contractReadsBurnableBalances = getContractReadsBurnableBalances(
        burnableContract,
        address,
        burnableIds,
        addresses.gumball,
        burnableEnabled,
        onSuccessBurnableBalances
    );

    const {
        error: errorReadBurnableBalances,
        isLoading: isLoadingBurnableBalances,
        refetch: refetchBurnableBalances,
    } = useContractReads(contractReadsBurnableBalances);

    //-----------Fetch burnable token data
    useEffect(() => {
        const getNftsForCollection = (address) =>
            fetch(
                `${
                    import.meta.env.VITE_API_BASE_URL
                }/data/gacha/burnable/${address}`
            )
                .then((response) => response.json())
                .then((actualData) => {
                    //console.log(`fetch: ${JSON.stringify(actualData)}`);
                    setBurnableNfts(actualData);
                })
                .catch((err) => {
                    console.log(err.message);
                });

        // call the async generator function
        if (burnableContract.length > 0 && !bunablesInitialized.current) {
            bunablesInitialized.current = true;
            getNftsForCollection(burnableContract);
        }
    }, [burnableContract]);

    //-------------need to fetch token metadata & images
    // for available tokens
    // first we need to read them in batches
    // for each token we will have contract address, token id and type (0=erc721,1=erc1155)
    // depending on type cal the contract.URI or contract.tokenURI method and get the metadata
    // from the metadata get the image.

    //get the infos of tokens
    //- read from the contract
    //- set up the next batch state
    const getInfos = async (startIndex, count) => {
        const result = await readContracts(
            contractReadAvalableInfos(addresses, startIndex, count)
        );

        const [_data] = result;

        console.log(
            `info fetched count ${_data.length}  starting at ${infoStartIndex} `
        );

        //copy all infos
        //let _allInfos = allInfos;
        let _infos = infos;

        //we need to turn this data into dictionary
        _data.map((item) => {
            const [_contract, _tokenId, _type] = item;
            const tokenId = _tokenId.toString();
            const key = `${_contract.toLowerCase()}:${tokenId}`;

            if (key in _infos) {
                //this token already exists just add to the count
                let value = _infos[key];
                let _count = value.count;
                value = {
                    ...value,
                    count: _count + 1,
                };
                _infos[key] = value;
                setInfos((prevAllInfos) => ({
                    ...prevAllInfos,
                    [key]: value,
                }));
            } else {
                //add the token
                const value = {
                    type: _type,
                    count: 1,
                    name: "",
                    symbol: "",
                    metadata: "",
                    imageUrl: "",
                };
                _infos[key] = value;
                setInfos((prevAllInfos) => ({
                    ...prevAllInfos,
                    [key]: value,
                }));
            }
        });

        setInfoFetchedCount((prev) => prev + _data.length);
    };

    const setSingleInfos = (
        contract,
        id,
        _name,
        _symbol,
        _metadata,
        _image
    ) => {
        let _infos = infos;
        const key = `${contract.toLowerCase()}:${id}`;
        //this key should already exist!
        if (key in _infos) {
            let value = _infos[key];
            value = {
                ...value,
                name: _name,
                symbol: _symbol,
                metadata: _metadata,
                imageUrl: _image,
            };
            setAllInfos((prevAllInfos) => ({ ...prevAllInfos, [key]: value }));
        }
    };

    const getImage = (data) => {
        if (data.image) {
            if (data.image.cachedUrl) return data.image.cachedUrl;
            if (data.image.thumbnailUrl) return data.image.thumbnailUrl;
            if (data.image.originalUrl) return data.image.originalUrl;
            if (data.image.pngUrl) return data.image.originalUrl;
        }

        if (data.raw && data.raw.metadata && data.raw.metadata.image) {
            return data.raw.metadata.image;
        }
        return "";
    };

    useEffect(() => {
        if (loadedPrizes && infosComplete) {
            let _useNfts = {};

            for (var key in infos) {
                if (Object.prototype.hasOwnProperty.call(infos, key)) {
                    const value = infos[key];
                    const fields = key.split(":");
                    const contract = fields[0].toLowerCase();
                    const tokenid = fields[1];

                    if (value.metadata == "" && nfts[contract]) {
                        const data = nfts[contract].find((obj) => {
                            return obj.tokenId == tokenid;
                        });

                        if (data) {
                            if (_useNfts[contract])
                                _useNfts[contract].push(data);
                            else _useNfts[contract] = [data];

                            setSingleInfos(
                                contract,
                                tokenid,
                                data.contract && data.contract.name
                                    ? data.contract.name
                                    : "Unknown",
                                data.contract && data.contract.symbol
                                    ? data.contract.symbol
                                    : "Unknown",
                                data.tokenUri ? data.tokenUri : "",
                                getImage(data)
                            );
                        } else {
                            console.log(
                                `data not found for ${contract} ${tokenid} `
                            );
                        }
                    }
                }
            }

            //TODO need to remove any NFTS that are not in infos
            //console.log(`useNFTS: ${JSON.stringify(_useNfts)}`);

            setUseNfts(_useNfts);

            setProcessingComplete(true);
        }
    }, [loadedPrizes, infos, infosComplete, nfts]);

    useEffect(() => {
        /* console.log(
            `setting group counts:  gumball loaded: ${gumballDataLoaded}  availableTokens: ${availableTokens} infoFetchedCount: ${infoFetchedCount}`
        ); */

        if (
            gumballDataLoaded &&
            availableTokens > 0 &&
            infoFetchedCount < availableTokens
        ) {
            let remain = availableTokens - infoFetchedCount;
            if (remain > groupCount) remain = groupCount;

            if (infoFetchedCount > 0) {
                setInfoStartIndex(infoFetchedCount);
                //console.log(`setting start index ${infoFetchedCount}`);
            }

            setInfoGroupCount(remain);
            //if (remain < 100) console.log(`setting group count ${remain}`);
        }
    }, [gumballDataLoaded, availableTokens, infoFetchedCount]);

    useEffect(() => {
        if (
            gumballDataLoaded &&
            infoFetchedCount < availableTokens &&
            infoStartIndex == infoFetchedCount &&
            infoGroupCount > 0 &&
            !infosComplete
        ) {
            /* console.log(
                `call GetInfos(): infosComplete: ${infosComplete} infoGroupCount: ${infoGroupCount} gumballDataLoaded: ${gumballDataLoaded} availableTokens: ${availableTokens} infoStartIndex: ${infoStartIndex} infoFetchedCount: ${infoFetchedCount}`
            ); */
            getInfos(infoStartIndex, infoGroupCount);
        }

        if (gumballDataLoaded && infoFetchedCount >= availableTokens) {
            console.log("setting infos complete!");
            setInfosComplete(true);
        }
    }, [
        infosComplete,
        infoGroupCount,
        gumballDataLoaded,
        availableTokens,
        infoStartIndex,
        infoFetchedCount,
    ]);

    //-------------------------------ANIMA READS
    const onSuccessAnima = (data) => {
        console.log("anima: " + JSON.stringify(data));

        const [_balance, _allowance] = data;

        setAnimaBalance(BigNumber.from(_balance.toString()));
        const bigBalance = BigNumber.from(_balance.toString())
            .div(BigNumber.from(10).pow(18))
            .toNumber();
        setAnimaDisplayBalance(bigBalance);

        setAnimaAllowance(BigNumber.from(_allowance.toString()));
        const bigAllowance = BigNumber.from(_allowance.toString())
            .div(BigNumber.from(10).pow(18))
            .toNumber();
        setAnimaDisplayAllowance(bigAllowance);
    };

    const contractReadsAnima = getContractReadsAnima(
        addresses,
        address,
        onSuccessAnima
    );

    const {
        error: errorAnima,
        isLoading: isLoadingAnima,
        refetch: refetchAnima,
    } = useContractReads(contractReadsAnima);

    useInterval(() => {
        refetchAnima();
    }, 15000);

    return (
        <div className={s.profile}>
            <div className={s.connect}>
                <ConnectButton
                    accountStatus={{
                        smallScreen: "avatar",
                        largeScreen: "full",
                    }}
                    chainStatus="none"
                />
            </div>

            {(!isConnected || !chain) && (
                <>
                    <div className={s.main}>Please connect your wallet!</div>
                </>
            )}

            {isConnected && chain && chain.id != 137 && (
                <>
                    <div className={s.wrongNetwork}>
                        Please connect to Polygon Network!
                    </div>
                </>
            )}

            {isConnected && chain && chain.id == 137 && (
                <>
                    <div className={s.container}>
                        {show == "prizes" ? (
                            <>
                                <button
                                    className={s.showButton}
                                    onClick={() => setShow("")}
                                >
                                    Show Gacha
                                </button>
                                <PrizeWallet nfts={useNfts} count={count} />
                            </>
                        ) : (
                            <>
                                <button
                                    className={s.showButton}
                                    onClick={() => setShow("prizes")}
                                    disabled={!processingComplete}
                                >
                                    Show Prizes
                                </button>
                                <GumballContainer
                                    wallet={address}
                                    addresses={addresses}
                                    loadedPrizes={loadedPrizes}
                                    processingComplete={processingComplete}
                                    prizesCount={prizesCount}
                                    animaCost={animaCost}
                                    animaAllowance={animaAllowance}
                                    animaDisplayCost={animaDisplayCost}
                                    animaBalance={animaBalance}
                                    animaDisplayBalance={animaDisplayBalance}
                                    animaDisplayAllowance={
                                        animaDisplayAllowance
                                    }
                                    burnableEnabled={burnableEnabled}
                                    burnableContract={burnableContract}
                                    burnableName={burnableName}
                                    burnableSymbol={burnableSymbol}
                                    burnableSelectedId={burnableSelectedId}
                                    burnableApproved={burnableApproved}
                                    setBurnableSelectedId={
                                        setBurnableSelectedId
                                    }
                                    maticCost={maticCost}
                                    maticDisplayCost={maticDisplayCost}
                                    maticEnabled={maticEnabled}
                                    maticBalance={maticBalance}
                                    maticDisplayBalance={maticDisplayBalance}
                                    availableTokens={availableTokens}
                                    lastType={lastType}
                                    setLastType={setLastType}
                                    burnableNfts={burnableNfts}
                                    burnableBalances={burnableBalances}
                                    infosComplete={infosComplete}
                                    paused={paused}
                                    allInfos={allInfos}
                                    refetchReadGumball={refetchReadGumball}
                                    refetchBurnableBalances={
                                        refetchBurnableBalances
                                    }
                                    setAllInfos={setAllInfos}
                                    refetchAnima={refetchAnima}
                                />
                            </>
                        )}
                    </div>
                    <div>Your wallet: {address}</div>
                    <Contracts addresses={addresses} />
                </>
            )}
        </div>
    );
};

export { Profile };
